<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="order-main-sidebar" position="left" lockedOpen="gt-md">
        <order-history-sidebar (filteredDateRange)="filterByDateRange($event)"></order-history-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <selling-navbar></selling-navbar>

        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Created at' | translate}}" prop="invoiceNumber">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.documentDate | date:'dd.MM.yyyy HH:mm:ss':'UTC+2'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Price' | translate}}" prop="invoiceNumber">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.priceGross| currency: ' '}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Worker' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.worker.firstName}} {{row.worker.lastName}} ({{row.worker.username}})
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Customer' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.customer">
                                    {{row.customer.firstName}} {{row.customer.lastName}}; {{row.customer.phone}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Online order' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.isOnlineOrder">
                                    {{'Yes'|translate}}
                                </span>
                                <span *ngIf="!row.isOnlineOrder">
                                    {{'No'|translate}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Assigned to card' | translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.isAssignedToCard">
                                    {{'Yes'|translate}}
                                </span>
                                <span *ngIf="!row.isAssignedToCard">
                                    {{'No'|translate}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a routerLink="/orders/details/{{row.id}}">{{'Details'|translate}}</a>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
